// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._nd5l11ig{grid-area:1/2/2/3}._1wpz1h6o{align-self:center}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/checkbox/dist/esm/internal/label-text.compiled.css"],"names":[],"mappings":";AACA,WAAW,iBAAiB,CAAC,WAAW,iBAAiB","sourcesContent":["\n._nd5l11ig{grid-area:1/2/2/3}._1wpz1h6o{align-self:center}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
